module.exports = __webpack_public_path__ + "img/empty.c12f6070.png";